import { Link } from "react-router-dom";
import { ShieldCheck, Check, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";

const POINTS = [
  "HVAC equipment is covered by the applicable manufacturer warranty",
  "Warranty length and coverage depend on the manufacturer and specific equipment",
  "Some manufacturer warranties require product registration and professional installation",
  "Verified manufacturer warranty details, where available, appear on the product page",
];

export default function Warranty() {
  return (
    <div>
      <Seo title="Warranty Information | CA HVAC Direct" description="HVAC equipment sold by CA HVAC Direct is covered by the applicable manufacturer warranty. Coverage and length vary by manufacturer and equipment." path="/warranty" />
      <section className="border-b border-slate-200 bg-slate-950">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
          <span className="inline-flex items-center gap-2 rounded-sm bg-sky-600/20 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-sky-300"><ShieldCheck className="h-4 w-4" /> Warranty</span>
          <h1 className="mt-4 font-heading text-4xl font-black tracking-tight text-white sm:text-5xl">Manufacturer Warranty Available</h1>
          <p className="mt-4 max-w-2xl text-slate-300">
            HVAC equipment sold by CA HVAC Direct is covered by the applicable manufacturer warranty. This page summarizes
            how warranty coverage works. Exact terms depend on the manufacturer and the specific equipment.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
          <ul className="space-y-4">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-sky-50 text-sky-700"><Check className="h-4 w-4" /></span>
                <span className="text-slate-700">{p}</span>
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button asChild className="rounded-sm bg-sky-700 hover:bg-sky-800"><Link to="/policies/warranty">Full warranty information <ArrowRight className="h-4 w-4" /></Link></Button>
            <Button asChild variant="outline" className="rounded-sm border-slate-300"><Link to="/shop">Shop Equipment</Link></Button>
          </div>
        </div>
      </section>
    </div>
  );
}
